/**
 * Navigation
 * Re-open the active dropdowns in the burger menu on page load
 */
;(() => {
	const header = document.querySelector('#header')
	const nav = header.querySelector('#navigation')
	if (nav === null) return

	let dropdownButtons = nav.querySelectorAll('.dropdown-toggle')
	dropdownButtons.forEach((dropdownButton) => {
		// get the parent dropdown menu
		const dropdownMenu = dropdownButton.closest('ul')

		// get all sibling buttons of this dropdown menu
		const siblingDropdownButtons = dropdownMenu.querySelectorAll(
			':scope > li > button'
		)

		// if the dropdown button gets opened (shown)
		dropdownButton.addEventListener('show.bs.dropdown', () => {
			// change shown sibling buttons
			siblingDropdownButtons.forEach((siblingButton) => {
				if (
					siblingButton.classList.contains('show') &&
					siblingButton !== dropdownButton
				) {
					siblingButton.classList.remove('show')
					siblingButton.setAttribute('aria-expanded', 'false')
					siblingButton.parentElement
						.querySelector('ul.show')
						.classList.remove('show')
				}
			})
		})
	})
})()
